import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { get } from 'lodash';

import Text from '../Text';
import Error from '../Field/Error';
import UploadFile from './UploadFile';
import { imageFileExtensions } from '../../helpers/media';

import style from "./style.module.css";

function Single(props) {
    const { label = false, input: { onChange }, dimension = false, hint = false, id = "file-upload", btnLabel = "Upload", extraClass = false, labelClass = false, formats = imageFileExtensions() } = props;
    const [upload, setUpload] = useState("");

    useEffect(() => {
        if (upload === "") {
            setUpload(get(props, "input.value.id", ""))
        }
        // eslint-disable-next-line
    }, [props.input]);

    const onFileChangeHandler = (e) => {
        if (e.target.value !== "") {
            let files = e.target.files;
            setUpload({
                filetime: moment().format('X'),
                file: files[0]
            });
            e.target.value = "";
        }
    }

    const onUploadChangeHandler = (response) => {
        if (response.status === 200) {
            let data = setCleanData(response);
            onChange(data);
        }
    }

    const onRemoveHandler = () => {
        onChange("");
        setUpload("");
    }

    const setCleanData = (item) => {
        if (item && item.id) {
            return item;
        }
        return "";
    }

    return (
        <>
            <div className={'flex flex-row'}>
                <Text {...props} text={label} />
                {dimension && <span className={`text-sm text-gray-800 pl-1`}>{`(Image should be ${dimension})`}</span>}
                {hint && <span className={`text-sm text-gray-800 pl-1`}>{hint}</span>}
            </div>

            <div className={`${extraClass && extraClass}`}>
                <label htmlFor={id} className={style.uploadBtn}>
                    <span className={`${labelClass && labelClass}`}>{btnLabel}</span>
                    <input type="file" id={id} className="sr-only" onChange={onFileChangeHandler} />
                </label>
                <UploadFile hideIcon={get(props, "hideIcon", false)} value={upload} onUpload={onUploadChangeHandler} onRemove={onRemoveHandler} formats={formats} />
                <Error {...props} />
            </div>
        </>
    );
}
export default Single;